import { autoserializeAs } from 'cerialize';
import { ConfigurationValue } from './configuration-value';

export class AutoPairTransitProgramConfiguration {
  @autoserializeAs(ConfigurationValue)
  initialWaitPeriod: ConfigurationValue;

  @autoserializeAs(ConfigurationValue)
  interestedDriversTriggerAmount: ConfigurationValue;

  @autoserializeAs(ConfigurationValue)
  minutesBeforePickupToForce: ConfigurationValue;

  @autoserializeAs(ConfigurationValue)
  onDemandInitialWaitPeriodMinutes: ConfigurationValue;

  @autoserializeAs(ConfigurationValue)
  onDemandOptimisticMinutes: ConfigurationValue;

  @autoserializeAs(ConfigurationValue)
  onDemandTimeWindow: ConfigurationValue;

  @autoserializeAs(ConfigurationValue)
  transitProgramPriority: ConfigurationValue;

  @autoserializeAs(ConfigurationValue)
  triggerWaitPeriodPercent: ConfigurationValue;

  @autoserializeAs(ConfigurationValue)
  onDemandProximityMinutes: ConfigurationValue;
}
